import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=3a084a16&scoped=true&"
import script from "./echarts.vue?vue&type=script&lang=js&"
export * from "./echarts.vue?vue&type=script&lang=js&"
import style0 from "./echarts.vue?vue&type=style&index=0&id=3a084a16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a084a16",
  null
  
)

export default component.exports